import { Pipe, PipeTransform } from '@angular/core';
import {
  faAngleDoubleUp,
  faAngleDown,
  faAngleUp,
  faEquals,
} from '@fortawesome/pro-solid-svg-icons';
import { ProfitabilityScoreSteps } from '@wilson/api/gateway';
@Pipe({
  name: 'profitabilityIcon',
  standalone: true,
})
export class ProfitabilityIconPipe implements PipeTransform {
  transform(
    profitabilityScore: number | null | undefined,
    profitabilityScoreSteps: ProfitabilityScoreSteps,
  ) {
    if (profitabilityScore == null) return;

    if (profitabilityScoreSteps) {
      const normalizedProfitabilityScoreSteps =
        this.normalizeProfitabilityScores(profitabilityScoreSteps);

      if (
        profitabilityScore >= normalizedProfitabilityScoreSteps.veryHigh.max
      ) {
        return {
          color: '#52C41A',
          name: faAngleDoubleUp,
          text: 'profitability_step_very_high',
        };
      } else if (
        profitabilityScore <= normalizedProfitabilityScoreSteps.negative.min
      ) {
        return {
          color: '#FF4D4F',
          name: faAngleDown,
          text: 'profitability_step_negative',
        };
      } else {
        for (const step in normalizedProfitabilityScoreSteps) {
          if (step !== 'veryHigh' && step !== 'negative') {
            const range = normalizedProfitabilityScoreSteps[step];
            if (
              profitabilityScore >= range.min &&
              profitabilityScore <= range.max
            ) {
              let color, name, text;
              switch (step) {
                case 'high':
                  color = '#B7EB8F';
                  name = faAngleUp;
                  text = 'profitability_step_high';
                  break;
                case 'moderate':
                  color = '#FFC53D';
                  name = faAngleUp;
                  text = 'profitability_step_moderate';
                  break;
                case 'low':
                  color = '#FFC53D';
                  name = faEquals;
                  text = 'profitability_step_low';
                  break;
              }
              return { color, name, text };
            }
          }
        }
      }
    }

    return { color: '', name: '', text: 'Unknown' };
  }

  private normalizeProfitabilityScores(
    scores: ProfitabilityScoreSteps,
  ): ProfitabilityScoreSteps {
    const normalizedScores: ProfitabilityScoreSteps =
      {} as ProfitabilityScoreSteps;

    for (const key in scores) {
      if (Object.prototype.hasOwnProperty.call(scores, key)) {
        normalizedScores[key] = {
          min: scores[key].min / 100,
          max: scores[key].max / 100,
        };
      }
    }

    return normalizedScores;
  }
}
